import AWS from 'aws-sdk'
import { CognitoUserPool, CognitoUser, AmazonCognitoIdentity, AuthenticationDetails, CognitoUserAttribute } from 'amazon-cognito-identity-js'
import { cognitoIdentityPoolId, cognitoUserPoolId, cognitoClientId, cognitoRegion } from './aws'
import { initApiGatewayClient, apiGatewayClient } from './api'
import { clearSubscriptions } from './api-catalog'


const poolData = {
  UserPoolId: cognitoUserPoolId,
  ClientId: cognitoClientId
}

let cognitoUser
let userPool
var authCognitoUser

export function isAuthenticated() {
  return cognitoUser
}

export function notAuthenticated() {
  cognitoUser = null;
}

export function apiReferenceAuthorize(nameIn, valueIn) {
  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();
  var attributeList = [];
  var attribute = {
        Name : nameIn,
        Value : valueIn
    };
  var pushAttribute = new AmazonCognitoIdentity.CognitoUserAttribute(attribute);
    attributeList.push(pushAttribute);

    cognitoUser.updateAttributes(attributeList, function(err, result) {
        if (err) {
            alert(err);
            return;
        }
        console.log('call result: ' + result);
    });
}


export function isAuthorized() {

  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();
  var displayName;
  var authorized = false;

  if (cognitoUser !== null){
      console.log(`User Account is ${cognitoUser.getUsername()}`);
  displayName = cognitoUser.getUsername();
  var authorizedNames = ["nsellers", "fluxdev", "brian.hargan@cmic.ca", "itsippis", "Chris.collins@ryvit.com", "michael.tumblin@ryvit.com", "speedwagon989", "awhitney"];
  if (authorizedNames.indexOf(displayName) !== -1 ){
    authorized = true;
  }else {
    authorized = false;
  }
}

console.log(`Authorized is currently: ${authorized}`);
return  authorized;

}

function getCognitoLoginKey() {
  return `cognito-idp.${cognitoRegion}.amazonaws.com/${cognitoUserPoolId}`
}




export function init() {
  // attempt to refresh credentials from active session
  userPool = new CognitoUserPool(poolData)
  cognitoUser = userPool.getCurrentUser()

  if (cognitoUser !== null) {
    cognitoUser.getSession(function(err, session) {
      if (err) {
        logout()
        console.error(err)
        return
      }

      const cognitoLoginKey = getCognitoLoginKey()
      const Logins = {}
      Logins[cognitoLoginKey] = session.getIdToken().getJwtToken()
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: cognitoIdentityPoolId,
        Logins: Logins
      })

      AWS.config.credentials.refresh((error) => {
        if (error) {
          logout()
          console.error(error)
        } else {
          initApiGatewayClient(AWS.config.credentials)
        }
      })
    })
  } else {
    initApiGatewayClient()
    // if (!/index\.html/.test(window.location.href)) {
    //   // window.location = 'index.html'
    //   return
    // } else {
    //   window.localStorage.removeItem('aws.cognito.identity-id.' + cognitoIdentityPoolId)
    //   window.localStorage.removeItem('aws.cognito.identity-providers.' + cognitoIdentityPoolId)
    // }
  }
}



export function register(username, email, password) {
  localStorage.clear()
  const attributeList = []

  //new code
  var dataEmail = {
    Name: 'email',
    Value: email
  };

  var attributeEmail = new CognitoUserAttribute(dataEmail);
  attributeList.push(attributeEmail);
  //end new code

  return new Promise((resolve, reject) => {
    userPool.signUp(username, password, attributeList, null, (err, result) => {
      if (err) {
        console.log(err)
        reject(err)
      } else {
        cognitoUser = result.user;
        console.log('user registered as this name: ' + cognitoUser.getUsername());
        resolve(result)
      }
    })
  })
}



export function doConfirm(username, code) {
        var userPool = new CognitoUserPool(poolData);
        var userData = {
            Username: username,
            Pool: userPool
        };

        var cognitoUser = new CognitoUser(userData);
        console.log(cognitoUser);
return new Promise((resolve, reject) => {
  cognitoUser.confirmRegistration(code, true, function(err, result) {
      if (err) {
          alert(err);
          return;
      }
      console.log('call result: ' + result);
      resolve(result)
  });


})
        // cognitoUser.confirmRegistration(code, true, function(err, result) {
        //     if (err) {
        //         alert(err);
        //         return;
        //     }
        //     console.log('call result: ' + result);
        // });


    }



export function forgotPassword(username){
  console.log("entering forgotpassword block")
  var userPool = new CognitoUserPool(poolData);
  var userData = {
    Username: username,
    Pool: userPool
  };
  var cognitoUser = new CognitoUser(userData);
  console.log(cognitoUser)
  cognitoUser.forgotPassword({

         onSuccess: function (result) {
             console.log('call send code result: ' + result);
         },
         onFailure: function(err) {
             alert(err);
         }/*,
         inputVerificationCode(verificationCode, newPassword) {
             /*var verificationCode = prompt('Please input verification code ' ,'');
             var newPassword = prompt('Enter new password ' ,'');
             cognitoUser.confirmPassword(verificationCode, newPassword, this);
         }*/
     });
}



export function confirmForgotPassword(username, verificationCode, newPassword){
  console.log("entering forgotpassword block")
  var userPool = new CognitoUserPool(poolData);
  console.log(username);
  console.log(verificationCode);
  console.log(newPassword);
  var userData = {
    Username: username,
    Pool: userPool
  };

  var cognitoUser = new CognitoUser(userData);

  //confirm({

            //inputVerificationCode(verificationCode, newPassword){
          //  var verificationCodeLocal =  verificationCode;
          //  var newPasswordLocal = newPassword;
            cognitoUser.confirmPassword(verificationCode, newPassword, this)
          /*,
            onSuccess: function (result) {
               console.log('call confirm result: ' + result);
            },
            onFailure: function(err) {
               alert("error");
               alert(err);
            }*/
  //});
//cognitoUser.confirmPassword(verificationCode, newPassword, this)
}



export function login(email, password) {
    const authenticationData = {
      Username: email,
      Password: password
    }
    const authenticationDetails = new AuthenticationDetails(authenticationData)
    userPool = new CognitoUserPool(poolData)
    const userData = {
      Username: email,
      Pool: userPool
    }

    cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          authCognitoUser = result.user
          console.log(`Cognito user set: ${authCognitoUser}`);
          console.log('access token + ' + result.getAccessToken().getJwtToken())

          const cognitoLoginKey = getCognitoLoginKey()
          const Logins = {}
          Logins[cognitoLoginKey] = result.getIdToken().getJwtToken()
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: cognitoIdentityPoolId,
            Logins: Logins
          })

          AWS.config.credentials.refresh((error) => {
            if (error) {
              console.error(error)
            } else {
              console.log('Successfully logged in')

              initApiGatewayClient(AWS.config.credentials)

              apiGatewayClient.post('/signin', {}, {}, {}).then((result) => {
                resolve(result)
              }).catch((err) => {
                reject(err)
              })
            }
          })
        },

        onFailure: (err) => {
          reject(err)
        }
    })
  })
}




export function getAttributes (){

  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();
  var username;
  console.log(username);
  if (cognitoUser != null) {
    cognitoUser.getSession(function(err, session) {
        if (err) {
            alert(err);
            return;
        }
        console.log('session validity: ' + session.isValid());
    });
}
  cognitoUser.getUserAttributes(function(err, result) {
        if (err) {
            alert(err);
            return;
        }
        for (var i = 0; i < result.length; i++) {
            console.log('attribute ' + result[i].getName() + ' has value ' + result[i].getValue());
            username = result[2].getValue();
        }

});

}



export function getUserAccount () {
  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();
  var displayName;
console.log(`User Account is ${cognitoUser.getUsername()}`);
displayName = cognitoUser.getUsername();
  return displayName;
}




export function updateEmail (newEmail){
//Get current user
  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();

  if (cognitoUser != null) {
    cognitoUser.getSession(function(err, session) {
        if (err) {
            alert(err);
            return;
        }
        console.log('session validity: ' + session.isValid());
    });
}

  console.log(`Cognito User inside updateEmail block:  ${cognitoUser}`);
//end Get current user

  const attributeList = [];
// var email = newEmail;
//
       var dataEmail = {
         Name : 'email',
         Value : newEmail
       };

      var attributeEmail = new CognitoUserAttribute(dataEmail);

      attributeList.push(attributeEmail);
      console.log(`Attribute List: ${attributeList}`);

return new Promise((resolve, reject) => {
    cognitoUser.updateAttributes(attributeList, (err, result) => {
          if (err) {
              alert(err);
              return;
          }
          console.log('call result: ' + result);
      });
});

}





export function confirmEmail(code){

  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();

  if (cognitoUser != null) {
    cognitoUser.getSession(function(err, session) {
        if (err) {
            alert(err);
            return;
        }
        console.log('session validity: ' + session.isValid());
    });
}

  console.log(`Cognito User inside Confirm Email block:  ${cognitoUser}`);
  cognitoUser.verifyAttribute('email', code, this, {
    onSuccess: function (result){
      console.log(`Your confirmation result is: ${result}`);
    },
    onFailure: function(err){
      alert(err);
    }


  });

}

export function deleteAccount(){
  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();

  if (cognitoUser != null) {
    cognitoUser.getSession(function(err, session) {
        if (err) {
            alert(err);
            return;
        }
        console.log('session validity: ' + session.isValid());
    });
}
cognitoUser.deleteUser(function(err, result) {
    if (err) {
        alert(err);
        return;
    }
    console.log('call result: ' + result);
});


}




export function logout() {
  cognitoUser.signOut()
  cognitoUser = null
  clearSubscriptions()
  localStorage.clear()
}

export function showApiKey() {
  return apiGatewayClient.get('/apikey', {}, {}, {}).then(({data}) => data.value)
}



/** WEBPACK FOOTER **
 ** ./src/services/self.js
 **/